import { render, staticRenderFns } from "./grade-info-doubleOld.vue?vue&type=template&id=67a8da56&scoped=true&lang=pug"
import script from "./grade-info-doubleOld.vue?vue&type=script&lang=js"
export * from "./grade-info-doubleOld.vue?vue&type=script&lang=js"
import style0 from "./grade-info-doubleOld.vue?vue&type=style&index=0&id=67a8da56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a8da56",
  null
  
)

export default component.exports